import React from 'react';
import logo from '../../assets/logo.png';
import { supabase } from '../../supabaseClient';

const Navbar = () => {
  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (!error) {
      window.location.href = '/';
    } else {
      console.error('Logout error:', error.message);
    }
  };

  return (
    <nav className="navbar navbar-expand-md bg-white shadow-sm sticky-top py-2 neumorph-nav">
      <div className="container">
        {/* Brand logo + text */}
        <a className="navbar-brand d-flex no-underline align-items-center" href="/dashboard">
          <img src={logo} alt="Partidul România Dreaptă și Prosperă" width="36" height="36" className="me-2" />
          <span className="fw-bold fs-5 text-primary-dark">PRDP</span>
        </a>

        {/* Toggler button for mobile */}
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav align-items-center gap-md-4">
            <li className="nav-item"><a className="nav-link fw-semibold" href="/dashboard">Acasă</a></li>
            <li className="nav-item"><a className="nav-link fw-semibold" href="/cereri-membru">Cereri Membri</a></li>
            <li className="nav-item"><a className="nav-link fw-semibold" href="/membri">Membri</a></li>
            <li className="nav-item"><a className="nav-link fw-semibold" href="/voluntari">Voluntari</a></li>
            <li className="nav-item"><a className="nav-link fw-semibold" href="/aplicatie-membri">PRDP Membri</a></li>
            <li className="nav-item"><a className="nav-link fw-semibold" href="/cotizatii">Cotizații</a></li>
            <li className="nav-item"><a className="nav-link fw-semibold" href="/petitii">Liste petiții</a></li>
            <li className="nav-item"><a className="nav-link fw-semibold" href="/trimite-mail">Trimite mail</a></li>
            <li className="nav-item"><a className="nav-link fw-semibold" href="/trimite-newsletter">Trimite newsletter</a></li>
            <li className="nav-item"><a className="nav-link fw-semibold" href="/setari">Setări</a></li>
            <li className="nav-item">
              <button onClick={handleLogout} className="btn neumorphism-button-logout btn-sm ms-md-3">
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
